'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Children, Component } from 'react';
import { omit } from '../../../utils';
import { getIsAdmin } from 'ui-addon-upgrades/_core/common/eligibility/getIsAdmin';
import { BILLING, MARKETABLE_CONTACTS_WRITE, TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as AdminModalTypes from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import AdminModal from './AdminModal';

var AdminOnlyWrapper = /*#__PURE__*/function (_Component) {
  _inherits(AdminOnlyWrapper, _Component);

  function AdminOnlyWrapper(props) {
    var _this;

    _classCallCheck(this, AdminOnlyWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdminOnlyWrapper).call(this, props));
    _this.state = {
      isAdmin: false,
      showAdminModal: false
    };
    return _this;
  }

  _createClass(AdminOnlyWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var adminType = this.props.adminType;
      getIsAdmin(adminType).then(function (isAdmin) {
        return _this2.setState({
          isAdmin: isAdmin
        });
      });
    }
  }, {
    key: "renderChild",
    value: function renderChild() {
      var _this3 = this;

      var isAdmin = this.state.isAdmin;
      var children = this.props.children;
      var child = Children.only(children);

      if (!isAdmin) {
        var newProps = omit(Object.assign({}, child.props, {
          onClick: function onClick() {
            return _this3.setState({
              showAdminModal: true
            });
          }
        }), 'href');
        return React.createElement(child.type, newProps);
      }

      return child;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var showAdminModal = this.state.showAdminModal;
      var _this$props = this.props,
          modalType = _this$props.modalType,
          merchandiseId = _this$props.merchandiseId;
      return React.createElement(React.Fragment, null, showAdminModal && React.createElement(AdminModal, {
        modalType: modalType,
        merchandiseId: merchandiseId,
        onClose: function onClose() {
          return _this4.setState({
            showAdminModal: false
          });
        }
      }), this.renderChild());
    }
  }]);

  return AdminOnlyWrapper;
}(Component);

AdminOnlyWrapper.defaultProps = {
  adminType: TEAM,
  modalType: AdminModalTypes.DEFAULT
};
AdminOnlyWrapper.propTypes = {
  adminType: PropTypes.oneOf([BILLING, TEAM, MARKETABLE_CONTACTS_WRITE]).isRequired,
  children: PropTypes.node.isRequired,
  merchandiseId: PropTypes.number,
  modalType: PropTypes.oneOf(Object.values(AdminModalTypes || {}))
};
export default AdminOnlyWrapper;